import { RouteType } from "types/RouteType";
import developerMetricsRoute from "./DeveloperMetrics/developerMetrics.Route";
import { reportsHubRoute } from "./ReportsHub/reportsHubRoute";

/**
 * Reports — the reports tool's hub (@intrasync/reports at /app/reports: the
 * catalog, run dialog, builder, saved views, schedules, history and admin
 * panel) and the read-only views over what HQ has measured (Developer Metrics).
 */
const reportsRoutesList: RouteType[] = [reportsHubRoute, developerMetricsRoute];

export default reportsRoutesList;
